import { ErrorHandler } from '../services/errorHandler'
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'

export const useNotifications = () => {
  const feedbackStore = useFeedbackStore()

  const showError = (error: unknown, context: string): void => {
    const errorInfo = ErrorHandler.handle(error, context)
    feedbackStore.showToast({
      type: 'error',
      message: errorInfo.message,
      time: 3000,
    })
  }

  const showSuccess = (message: string): void => {
    feedbackStore.showToast({
      type: 'success',
      message,
      time: 3000,
    })
  }

  const showInfo = (message: string): void => {
    feedbackStore.showToast({
      type: 'info',
      message,
      time: 3000,
    })
  }

  const showWarning = (message: string): void => {
    feedbackStore.showToast({
      type: 'warning',
      message,
      time: 3000,
    })
  }

  return {
    showError,
    showSuccess,
    showInfo,
    showWarning,
  }
}
